enum TextButtonTheme {
  Primary = "Primary",
}

export default TextButtonTheme;
